(function webpackUniversalModuleDefinition(root, factory) {
  if (typeof exports === 'object' && typeof module === 'object') module.exports = factory(require("react"), require("prop-types"), require("classnames"), require("@material/top-app-bar/dist/mdc.topAppBar"));else if (typeof define === 'function' && define.amd) define(["react", "prop-types", "classnames", "@material/top-app-bar/dist/mdc.topAppBar"], factory);else {
    var a = typeof exports === 'object' ? factory(require("react"), require("prop-types"), require("classnames"), require("@material/top-app-bar/dist/mdc.topAppBar")) : factory(root["react"], root["prop-types"], root["classnames"], root["@material/top-app-bar/dist/mdc.topAppBar"]);

    for (var i in a) {
      (typeof exports === 'object' ? exports : root)[i] = a[i];
    }
  }
})(typeof self !== 'undefined' ? self : this, function (__WEBPACK_EXTERNAL_MODULE_0__, __WEBPACK_EXTERNAL_MODULE_1__, __WEBPACK_EXTERNAL_MODULE_2__, __WEBPACK_EXTERNAL_MODULE_5__) {
  return (
    /******/
    function (modules) {
      // webpackBootstrap

      /******/
      // The module cache

      /******/
      var installedModules = {};
      /******/

      /******/
      // The require function

      /******/

      function __webpack_require__(moduleId) {
        /******/

        /******/
        // Check if module is in cache

        /******/
        if (installedModules[moduleId]) {
          /******/
          return installedModules[moduleId].exports;
          /******/
        }
        /******/
        // Create a new module (and put it into the cache)

        /******/


        var module = installedModules[moduleId] = {
          /******/
          i: moduleId,

          /******/
          l: false,

          /******/
          exports: {}
          /******/

        };
        /******/

        /******/
        // Execute the module function

        /******/

        modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
        /******/

        /******/
        // Flag the module as loaded

        /******/

        module.l = true;
        /******/

        /******/
        // Return the exports of the module

        /******/

        return module.exports;
        /******/
      }
      /******/

      /******/

      /******/
      // expose the modules object (__webpack_modules__)

      /******/


      __webpack_require__.m = modules;
      /******/

      /******/
      // expose the module cache

      /******/

      __webpack_require__.c = installedModules;
      /******/

      /******/
      // define getter function for harmony exports

      /******/

      __webpack_require__.d = function (exports, name, getter) {
        /******/
        if (!__webpack_require__.o(exports, name)) {
          /******/
          Object.defineProperty(exports, name, {
            /******/
            configurable: false,

            /******/
            enumerable: true,

            /******/
            get: getter
            /******/

          });
          /******/
        }
        /******/

      };
      /******/

      /******/
      // getDefaultExport function for compatibility with non-harmony modules

      /******/


      __webpack_require__.n = function (module) {
        /******/
        var getter = module && module.__esModule ?
        /******/
        function getDefault() {
          return module['default'];
        } :
        /******/
        function getModuleExports() {
          return module;
        };
        /******/

        __webpack_require__.d(getter, 'a', getter);
        /******/


        return getter;
        /******/
      };
      /******/

      /******/
      // Object.prototype.hasOwnProperty.call

      /******/


      __webpack_require__.o = function (object, property) {
        return Object.prototype.hasOwnProperty.call(object, property);
      };
      /******/

      /******/
      // __webpack_public_path__

      /******/


      __webpack_require__.p = "";
      /******/

      /******/
      // Load entry module and return exports

      /******/

      return __webpack_require__(__webpack_require__.s = 3);
      /******/
    }(
    /************************************************************************/

    /******/
    [
    /* 0 */

    /***/
    function (module, exports) {
      module.exports = __WEBPACK_EXTERNAL_MODULE_0__;
      /***/
    },
    /* 1 */

    /***/
    function (module, exports) {
      module.exports = __WEBPACK_EXTERNAL_MODULE_1__;
      /***/
    },
    /* 2 */

    /***/
    function (module, exports) {
      module.exports = __WEBPACK_EXTERNAL_MODULE_2__;
      /***/
    },
    /* 3 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.TopAppBarFixedAdjust = undefined;

      var _extends = Object.assign || function (target) {
        for (var i = 1; i < arguments.length; i++) {
          var source = arguments[i];

          for (var key in source) {
            if (Object.prototype.hasOwnProperty.call(source, key)) {
              target[key] = source[key];
            }
          }
        }

        return target;
      };

      var _createClass = function () {
        function defineProperties(target, props) {
          for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
          }
        }

        return function (Constructor, protoProps, staticProps) {
          if (protoProps) defineProperties(Constructor.prototype, protoProps);
          if (staticProps) defineProperties(Constructor, staticProps);
          return Constructor;
        };
      }();

      var _react = __webpack_require__(0);

      var _react2 = _interopRequireDefault(_react);

      var _propTypes = __webpack_require__(1);

      var _propTypes2 = _interopRequireDefault(_propTypes);

      var _classnames = __webpack_require__(2);

      var _classnames2 = _interopRequireDefault(_classnames);

      var _FixedAdjust = __webpack_require__(4);

      var _FixedAdjust2 = _interopRequireDefault(_FixedAdjust);

      var _mdc = __webpack_require__(5);

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }

      function _objectWithoutProperties(obj, keys) {
        var target = {};

        for (var i in obj) {
          if (keys.indexOf(i) >= 0) continue;
          if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
          target[i] = obj[i];
        }

        return target;
      }

      function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
        }
      }

      function _possibleConstructorReturn(self, call) {
        if (!self) {
          throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        }

        return call && (typeof call === "object" || typeof call === "function") ? call : self;
      }

      function _inherits(subClass, superClass) {
        if (typeof superClass !== "function" && superClass !== null) {
          throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
        }

        subClass.prototype = Object.create(superClass && superClass.prototype, {
          constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
          }
        });
        if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
      } // The MIT License
      //
      // Copyright (c) 2018 Google, Inc.
      //
      // Permission is hereby granted, free of charge, to any person obtaining a copy
      // of this software and associated documentation files (the "Software"), to deal
      // in the Software without restriction, including without limitation the rights
      // to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
      // copies of the Software, and to permit persons to whom the Software is
      // furnished to do so, subject to the following conditions:
      //
      // The above copyright notice and this permission notice shall be included in
      // all copies or substantial portions of the Software.
      //
      // THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
      // IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
      // FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
      // AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
      // LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
      // OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
      // THE SOFTWARE.


      var TopAppBar = function (_React$Component) {
        _inherits(TopAppBar, _React$Component);

        function TopAppBar(props) {
          _classCallCheck(this, TopAppBar);

          var _this = _possibleConstructorReturn(this, (TopAppBar.__proto__ || Object.getPrototypeOf(TopAppBar)).call(this, props));

          _this.foundation_ = null;
          _this.state = {
            classList: new Set()
          };

          _this.initializeFoundation = function () {
            if (_this.props.short) {
              _this.foundation_ = new _mdc.MDCShortTopAppBarFoundation(_this.adapter);
            } else if (_this.props.fixed) {
              _this.foundation_ = new _mdc.MDCFixedTopAppBarFoundation(_this.adapter);
            } else {
              _this.foundation_ = new _mdc.MDCTopAppBarFoundation(_this.adapter);
            }

            _this.foundation_.init();
          };

          _this.getMergedStyles = function () {
            var style = _this.state.style;
            return Object.assign({}, style, _this.props.style);
          };

          _this.topAppBarElement = _react2.default.createRef();
          return _this;
        }

        _createClass(TopAppBar, [{
          key: 'componentDidMount',
          value: function componentDidMount() {
            this.initializeFoundation();
          }
        }, {
          key: 'componentWillUnmount',
          value: function componentWillUnmount() {
            this.foundation_.destroy();
          }
        }, {
          key: 'addClassesToElement',
          value: function addClassesToElement(classes, element) {
            var updatedProps = {
              className: (0, _classnames2.default)(classes, element.props.className)
            };
            return _react2.default.cloneElement(element, updatedProps);
          }
        }, {
          key: 'enableRippleOnElement',
          value: function enableRippleOnElement(element) {
            // If `element` is a Native React Element, throw error to enforce
            // ripple
            if (typeof element.type === 'string') {
              var errorText = 'Material Design requires all Top App Bar Icons to ' + 'have ripple. Please use @material/react-ripple HOC with your icons.';
              throw new Error(errorText);
            }

            return _react2.default.cloneElement(element, {
              hasRipple: true
            });
          }
        }, {
          key: 'render',
          value: function render() {
            return _react2.default.createElement('header', _extends({}, this.otherProps, {
              className: this.classes,
              style: this.getMergedStyles(),
              ref: this.topAppBarElement
            }), _react2.default.createElement('div', {
              className: 'mdc-top-app-bar__row'
            }, this.renderTitleAndNavigationSection(), this.renderActionItems()));
          }
        }, {
          key: 'renderTitleAndNavigationSection',
          value: function renderTitleAndNavigationSection() {
            var title = this.props.title;
            var classes = 'mdc-top-app-bar__section mdc-top-app-bar__section--align-start';
            return _react2.default.createElement('section', {
              className: classes
            }, this.renderNavigationIcon(), _react2.default.createElement('span', {
              className: 'mdc-top-app-bar__title'
            }, title));
          }
        }, {
          key: 'renderNavigationIcon',
          value: function renderNavigationIcon() {
            var navigationIcon = this.props.navigationIcon;

            if (!navigationIcon) {
              return;
            }

            var elementWithClasses = this.addClassesToElement('mdc-top-app-bar__navigation-icon', navigationIcon);
            return this.enableRippleOnElement(elementWithClasses);
          }
        }, {
          key: 'renderActionItems',
          value: function renderActionItems() {
            var _this2 = this;

            var actionItems = this.props.actionItems;

            if (!actionItems) {
              return;
            }

            return _react2.default.createElement('section', {
              className: 'mdc-top-app-bar__section mdc-top-app-bar__section--align-end',
              role: 'toolbar'
            }, actionItems.map(function (item, key) {
              var elementWithClasses = _this2.addClassesToElement('mdc-top-app-bar__action-item', item);

              var elementWithRipple = _this2.enableRippleOnElement(elementWithClasses);

              return _react2.default.cloneElement(elementWithRipple, {
                key: key
              });
            }));
          }
        }, {
          key: 'classes',
          get: function get() {
            var classList = this.state.classList;
            var _props = this.props,
                className = _props.className,
                fixed = _props.fixed,
                prominent = _props.prominent,
                short = _props.short,
                shortCollapsed = _props.shortCollapsed;
            return (0, _classnames2.default)('mdc-top-app-bar', Array.from(classList), className, {
              'mdc-top-app-bar--fixed': fixed,
              'mdc-top-app-bar--short': shortCollapsed || short,
              'mdc-top-app-bar--short-collapsed': shortCollapsed,
              'mdc-top-app-bar--prominent': prominent
            });
          }
        }, {
          key: 'adapter',
          get: function get() {
            var _this3 = this;

            var actionItems = this.props.actionItems;
            return {
              addClass: function addClass(className) {
                return _this3.setState({
                  classList: _this3.state.classList.add(className)
                });
              },
              removeClass: function removeClass(className) {
                var classList = _this3.state.classList;
                classList.delete(className);

                _this3.setState({
                  classList: classList
                });
              },
              hasClass: function hasClass(className) {
                return _this3.classes.split(' ').includes(className);
              },
              setStyle: function setStyle(varName, value) {
                var updatedStyle = Object.assign({}, _this3.state.style);
                updatedStyle[varName] = value;

                _this3.setState({
                  style: updatedStyle
                });
              },
              getTopAppBarHeight: function getTopAppBarHeight() {
                if (_this3.topAppBarElement && _this3.topAppBarElement.current) {
                  return _this3.topAppBarElement.current.clientHeight;
                }
              },
              registerScrollHandler: function registerScrollHandler(handler) {
                return window.addEventListener('scroll', handler);
              },
              deregisterScrollHandler: function deregisterScrollHandler(handler) {
                return window.removeEventListener('scroll', handler);
              },
              getViewportScrollY: function getViewportScrollY() {
                return window.pageYOffset;
              },
              getTotalActionItems: function getTotalActionItems() {
                return !!(actionItems && actionItems.length);
              }
            };
          }
        }, {
          key: 'otherProps',
          get: function get() {
            var _props2 = this.props,
                actionItems = _props2.actionItems,
                className = _props2.className,
                fixed = _props2.fixed,
                title = _props2.title,
                navigationIcon = _props2.navigationIcon,
                short = _props2.short,
                shortCollapsed = _props2.shortCollapsed,
                prominent = _props2.prominent,
                otherProps = _objectWithoutProperties(_props2, ['actionItems', 'className', 'fixed', 'title', 'navigationIcon', 'short', 'shortCollapsed', 'prominent']);

            return otherProps;
          }
        }]);

        return TopAppBar;
      }(_react2.default.Component);

      exports.default = TopAppBar;
      TopAppBar.propTypes = {
        actionItems: _propTypes2.default.arrayOf(_propTypes2.default.element),
        className: _propTypes2.default.string,
        fixed: _propTypes2.default.bool,
        navigationIcon: _propTypes2.default.element,
        prominent: _propTypes2.default.bool,
        short: _propTypes2.default.bool,
        shortCollapsed: _propTypes2.default.bool,
        style: _propTypes2.default.object,
        title: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.element])
      };
      TopAppBar.defaultProps = {
        actionItems: null,
        className: '',
        fixed: false,
        navigationIcon: null,
        prominent: false,
        short: false,
        shortCollapsed: false,
        style: {},
        title: ''
      };
      exports.TopAppBarFixedAdjust = _FixedAdjust2.default;
      /***/
    },
    /* 4 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });

      var _extends = Object.assign || function (target) {
        for (var i = 1; i < arguments.length; i++) {
          var source = arguments[i];

          for (var key in source) {
            if (Object.prototype.hasOwnProperty.call(source, key)) {
              target[key] = source[key];
            }
          }
        }

        return target;
      };

      var _react = __webpack_require__(0);

      var _react2 = _interopRequireDefault(_react);

      var _propTypes = __webpack_require__(1);

      var _propTypes2 = _interopRequireDefault(_propTypes);

      var _classnames = __webpack_require__(2);

      var _classnames2 = _interopRequireDefault(_classnames);

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }

      function _objectWithoutProperties(obj, keys) {
        var target = {};

        for (var i in obj) {
          if (keys.indexOf(i) >= 0) continue;
          if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
          target[i] = obj[i];
        }

        return target;
      } // The MIT License
      //
      // Copyright (c) 2018 Google, Inc.
      //
      // Permission is hereby granted, free of charge, to any person obtaining a copy
      // of this software and associated documentation files (the "Software"), to deal
      // in the Software without restriction, including without limitation the rights
      // to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
      // copies of the Software, and to permit persons to whom the Software is
      // furnished to do so, subject to the following conditions:
      //
      // The above copyright notice and this permission notice shall be included in
      // all copies or substantial portions of the Software.
      //
      // THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
      // IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
      // FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
      // AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
      // LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
      // OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
      // THE SOFTWARE.


      var FixedAdjust = function FixedAdjust(props) {
        var Tag = props.tag,
            children = props.children,
            className = props.className,
            otherProps = _objectWithoutProperties(props, ['tag', 'children', 'className']);

        return _react2.default.createElement(Tag, _extends({
          className: (0, _classnames2.default)('mdc-top-app-bar--fixed-adjust', className)
        }, otherProps), children);
      };

      FixedAdjust.propTypes = {
        tag: _propTypes2.default.string,
        children: _propTypes2.default.node.isRequired,
        className: _propTypes2.default.string
      };
      FixedAdjust.defaultProps = {
        tag: 'main',
        className: ''
      };
      exports.default = FixedAdjust;
      /***/
    },
    /* 5 */

    /***/
    function (module, exports) {
      module.exports = __WEBPACK_EXTERNAL_MODULE_5__;
      /***/
    }])
  );
});